import ScrollReveal from '../../../components/ui/ScrollReveal';

const pillars = [
  { icon: 'ri-focus-3-line', title: 'Technique First', desc: 'Flawless form on every rep — protecting your body while maximising results.' },
  { icon: 'ri-bar-chart-line', title: 'Progressive Programming', desc: 'Structured overload that evolves week by week as you grow stronger.' },
  { icon: 'ri-heart-pulse-line', title: 'Holistic Approach', desc: 'Training, nutrition and mindset working in harmony as one system.' },
];

export default function ResultsSection() {
  return (
    <section className="bg-[#faf8f5] py-16 lg:py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-10 items-stretch">

          {/* Image */}
          <ScrollReveal className="lg:col-span-3">
            <div className="relative h-[500px] rounded-2xl overflow-hidden group shadow-xl shadow-stone-200">
              <img
                src="/images/MIH02370_2.jpg"
                alt="Laura Martin personal trainer London coaching strength session"
                loading="lazy"
                className="w-full h-full object-cover object-[50%_20%] transition-transform duration-700 group-hover:scale-[1.03]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-stone-900/60 via-transparent to-transparent" />
              <div className="absolute bottom-8 left-8">
                <p className="text-white font-semibold text-4xl leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                  Real Results.
                  <br />
                  <em className="text-[#c9a96e] not-italic">Every Time.</em>
                </p>
              </div>
            </div>
          </ScrollReveal>

          {/* Pillars */}
          <div className="lg:col-span-2 flex flex-col justify-between gap-4">
            <ScrollReveal>
              <div className="flex items-center gap-4 mb-3">
                <span className="w-8 h-px bg-[#c9a96e]" />
                <span className="text-[#c9a96e] text-[10px] font-sans font-semibold tracking-[0.32em] uppercase">The Approach</span>
              </div>
              <h2
                className="text-stone-900 mb-8"
                style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 'clamp(2rem, 3.5vw, 3rem)', fontWeight: 600, lineHeight: 1.1 }}
              >
                Why Clients
                <br />
                Choose Laura.
              </h2>
            </ScrollReveal>

            {pillars.map((p, i) => (
              <ScrollReveal key={p.title} delay={(i + 1) * 100}>
                <div className="bg-white border border-stone-200 rounded-xl p-6 flex gap-5 group hover:border-[#c9a96e]/30 hover:shadow-md transition-all duration-300 cursor-default">
                  <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center bg-[#c9a96e]/8 rounded-lg">
                    <i className={`${p.icon} text-xl text-[#c9a96e]`} />
                  </div>
                  <div>
                    <h3 className="text-stone-900 text-sm font-sans font-bold tracking-wide mb-1.5">{p.title}</h3>
                    <p className="text-stone-500 font-sans text-xs leading-relaxed">{p.desc}</p>
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
